import { Wait16, Button, Outside } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface IComplaintButtonNewProps {
  tooltip: React.ReactNode;
  tooltipOpened: boolean;
  onButtonClick(): void;
  onTooltipClose(): void;
}

export function ComplaintButtonNew({
  tooltipOpened,
  tooltip,
  onTooltipClose,
  onButtonClick,
}: IComplaintButtonNewProps) {
  return (
    <span className={styles['container']}>
      <Button theme="stroke_secondary" beforeIcon={<Wait16 color="gray_icons_100" />} onClick={onButtonClick} size="XS">
        Пожаловаться
      </Button>
      {tooltipOpened && (
        <Outside onOutside={onTooltipClose} active={tooltipOpened} insideRefs={[]}>
          <div className={styles['tooltip']}>{tooltip}</div>
        </Outside>
      )}
    </span>
  );
}
